<template>
  <svg :width="width" :height="height" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_55_185)">
      <g clip-path="url(#clip0_55_185)">
        <path d="M12 28C12 16.9543 20.9543 8 32 8V8C43.0457 8 52 16.9543 52 28V48H32C20.9543 48 12 39.0457 12 28V28Z" fill="#FAFAFA" />
        <path
          d="M32.1768 26.3232C32.2744 26.4209 32.2744 26.5791 32.1768 26.6768C32.0791 26.7744 31.9209 26.7744 31.8232 26.6768C31.7256 26.5791 31.7256 26.4209 31.8232 26.3232C31.9209 26.2256 32.0791 26.2256 32.1768 26.3232"
          :stroke="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M36.1768 26.3232C36.2744 26.4209 36.2744 26.5791 36.1768 26.6768C36.0791 26.7744 35.9209 26.7744 35.8232 26.6768C35.7256 26.5791 35.7256 26.4209 35.8232 26.3232C35.9209 26.2256 36.0791 26.2256 36.1768 26.3232"
          :stroke="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M28.1768 26.3232C28.2744 26.4209 28.2744 26.5791 28.1768 26.6768C28.0791 26.7744 27.9209 26.7744 27.8232 26.6768C27.7256 26.5791 27.7256 26.4209 27.8232 26.3232C27.9209 26.2256 28.0791 26.2256 28.1768 26.3232"
          :stroke="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M32 37L28 33.001V33H25C23.895 33 23 32.105 23 31V21C23 19.895 23.895 19 25 19H39C40.105 19 41 19.895 41 21V31C41 32.105 40.105 33 39 33H36L32 36.999"
          :stroke="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <path d="M52 50H54V48V28C54 15.8497 44.1503 6 32 6C19.8497 6 10 15.8497 10 28C10 40.1503 19.8497 50 32 50H52Z" :stroke="color" stroke-width="4" />
    </g>
    <defs>
      <filter id="filter0_d_55_194" x="0" y="0" width="64" height="64" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_55_194" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_55_194" result="shape" />
      </filter>
      <clipPath id="clip0_55_194">
        <path d="M12 28C12 16.9543 20.9543 8 32 8V8C43.0457 8 52 16.9543 52 28V48H32C20.9543 48 12 39.0457 12 28V28Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'Icon1',
  props: {
    color: {
      type: String,
      default: '#000',
    },
    width: {
      type: Number,
      default: 96,
    },
    height: {
      type: Number,
      default: 96,
    },
  },
};
</script>
